module.exports = __webpack_public_path__ + "img/productHSE_12.0ccc12b3.png";